import {NgModule} from '@angular/core';
import {ClauseLinkRequiredToDisplayNamePipe} from './clause-link-required-to-display-name.pipe';

@NgModule({
  declarations: [ClauseLinkRequiredToDisplayNamePipe],
  exports: [ClauseLinkRequiredToDisplayNamePipe],
})
export class ClauseLinkRequiredToDisplayNameModule {}
